import * as types from './types';

const initialState = {
    characters: [],
    currentAgent: {},
    agentsByKeys: {},
    subStores: [],
};

const agentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_AGENTS_CHARACTERS_SUCCESS: {
            return {
                ...state,
                characters: action.payload.characters || state.characters,
                subStores: action.payload.subStores,
            };
        }

        case types.GET_AGENTS_CHARACTER_SUCCESS: {
            return {
                ...state,
                currentAgent: action.payload.data,
            };
        }

        case types.UNSET_CURRENT_AGENT: {
            return {
                ...state,
                currentAgent: {},
            };
        }

        default:
            return state;
    }
};

export default agentsReducer;
